module.exports = __webpack_public_path__ + "static/banner-8db3062819b945870cf970932c37e2b6.png";